fx.ns("shared.screens", class UpsellSecondScreen extends shared.screens.BaseUpsellScreen
{
	constructor() {
		super();
		this.title = fx.text("");
	}

	create() {
		const pageOptions = this._getOptionByIndex(1);
		this.choices = this.buildChoicesFromOptions(pageOptions ? pageOptions.options : []);
		if (this.choices.length > 0)
            this.build();
		super.create();
	}

	onReady(){
		super.onReady();
		this._updateNextButton();
	}

	// We display only order button because it's the last upsell page.
	_updateNextButton() {
		if (this.nextButton) this.nextButton.hide();
		if (this.nextButtonWithoutOption) this.nextButtonWithoutOption.hide();
		if (this.nextButtonOrder) this.nextButtonOrder.show();
	}

});